import { all } from 'redux-saga/effects';
import {
  watchLogin,
  watchForgotPassword,
  watchLogout,
} from '../redux/auth/sagas/authSaga';
import { watchVerifyEmailSaga } from '../redux/auth/sagas/verifyEmailSaga';
import { watchCustomerActions } from '../redux/Customers/sagas/customerSaga';
import {
  watchAddRole,
  watchDeleteRole,
  watchFetchRoleDetails,
  watchFetchRoles,
  watchUpdateRole,
} from './Roles/sagas/rolesSaga';
import { watchVendorActions } from './Vendors/sagas/vendorSaga';
import watchAirport from './Airports/sagas/airportSaga';
import staffSaga from './Staff/StaffSaga';
import changePasswordSaga from './changePassword/ChangePasswordSaga';
import serviceSaga from './Service/ServiceSaga';
import selectorSaga from './Common/selectorSaga';
import { watchResetPassword } from './auth/sagas/resetPasswordSaga';
import updateProfileSaga from './ProfileUpdate/profileUpdateSaga';
import userSaga from './User/UserSaga';
import bookingSaga from './Bookings/BookingSaga';
import { watchUploadFile } from './UploadCSV/UploadCsvSaga';
import billingAddressWatcherSaga from './BillingAddress/BillingAddressSaga';
import dashboardSaga from './Dashboard/DashboardSaga';
import {
  familyMemberWatcherSaga,
  watchFamilyMemberForm,
} from './FamilyMembers/sagas';
import { watchInsertOrder } from './Payments/paymentSaga';
import invoiceSaga from './Invoice/InvoiceSaga';

export default function* rootSaga() {
  yield all([
    watchLogin(),
    watchLogout(),
    watchForgotPassword(),
    watchVerifyEmailSaga(),
    watchAddRole(),
    watchFetchRoles(),
    watchUpdateRole(),
    watchFetchRoleDetails(),
    watchDeleteRole(),
    watchCustomerActions(),
    watchVendorActions(),
    watchAirport(),
    staffSaga(),
    changePasswordSaga(),
    serviceSaga(),
    selectorSaga(),
    watchResetPassword(),
    updateProfileSaga(),
    userSaga(),
    bookingSaga(),
    invoiceSaga(),
    watchUploadFile(),
    billingAddressWatcherSaga(),
    dashboardSaga(),
    familyMemberWatcherSaga(),
    watchInsertOrder(),
  ]);
}
